
import './App.css';
import Links from './components/links';
function App() {
  return (
    <main className='container'className="modal modal-sheet position-static d-block bg-dark py-5" tabIndex="-1" role="dialog" id="modalSheet">
      <Links></Links>
    </main>
   
  );
}

export default App;
